<template>
    <div class="body-panel dataContent">
        <template v-if="material != null">
            <div class="body-panel-control separator">
                <div class="control-block-left">
                    <div class="flex">
                        <p class="btn-back margin-right-10">
                            <a class="router-link-active" href="" @click.prevent="$router.push('/materials/')">Назад</a>
                        </p>
                        <p class="caption-help margin-right-10" v-if="material.new">Добавление материала</p>
                        <p class="caption-help" v-if="!material.new">Редактирование материала #{{ material.Id }}</p>
                    </div>
                </div>
                <div class="control-block-right">
                    <div class="btns flex">
                        <button type="button" class="btn btn-primary" @click="saveMaterial()" :disabled="savingInProgress">Сохранить</button>
                        <button type="button" class="btn btn-delete"
                                @click="deleteMaterial()"
                                v-if="material.ConvectorStatus !== 1">
                            Удалить
                        </button>
                    </div>
                </div>
            </div>
            <div class="body-panel-content body-panel-content-page">
                <div class="body-panel">
                    <div class="block-in-page closed">
                        <h2 class="margin-bottom-10 block-in-page-collapce">Общие настройки</h2>
                        <div class="block-in-page-detail">
                            <div class="form-field">
                                <label class="input-text-lbl">
                                    Название
                                    <span class="required" aria-required="true">*</span>
                                </label>
                                <textarea name="Name" rows="2" style="height:60px" :class="['input-memo', {'input-error': errors.has('Name')}]" v-validate="'required'" v-model="material.Name"></textarea>
                                <span class="field-validation-valid">{{ errors.first('Name') }}</span>
                            </div>
                            <div class="form-field">
                                <label class="input-text-lbl">
                                    Описание материала
                                    <span class="required" aria-required="true">*</span>
                                </label>
                                <froala-editor ref="Description" name="Description"
                                               :class="[{'input-error': errors.has('Description')}]"
                                               height="200"
                                               v-validate="'required'"
                                               v-model="material.Description"
                                               :imageUploadURL="config.apiUrl + '/api/materials/uploadFiles?fileType=Image&materialId=' + material.Id + '&projectId=' + material.ProjectId">

                                </froala-editor>
                                <span class="field-validation-valid">{{ errors.first('Description') }}</span>
                            </div>
                            <div class="form-field">
                                <label class="input-text-lbl">
                                    Категория
                                </label>
                                <input name="Category" :class="['input-text', {'input-error': errors.has('Category')}]" type="text" v-model="material.Category">
                            </div>

                            <div class="form-field">
                                <label class="input-text-lbl">
                                    Расположение материала
                                </label>
                                <drop-down :withSelectItem="'true'"
                                           :items="folders"
                                           :dataField="'Id'"
                                           :textField="'Name'"
                                           v-model="material.FolderId"></drop-down>
                            </div>


                            <div class="line-separator margin-bottom-15 margin-top-20"></div>

                            <template v-if="!material.new">
                                <div class="form-field">
                                    <input name="Status" id="St2" value="2" type="radio" class="input-checkbox"
                                           @change="onStatusChanged($event)" v-model.number="material.Status" />
                                    <label for="St2" class="input-checkbox-lbl">Активен</label>
                                </div>
                                <div class="form-field">
                                    <input name="Status" id="St3" value="3" type="radio" class="input-checkbox"
                                           @change="onStatusChanged($event)" v-model.number="material.Status" />
                                    <label for="St3" class="input-checkbox-lbl">В архиве</label>
                                </div>
                            </template>

                            <div class="line-separator margin-bottom-15 margin-top-20"></div>

                            <div class="form-field margin-top-10">
                                <input id="LikesEnabled" name="LikesEnabled" value="true" type="checkbox" class="input-checkbox" v-model="material.LikesEnabled" />
                                <label for="LikesEnabled" class="input-checkbox-lbl">Разрешить ставить лайки</label>
                            </div>
                            <div class="form-field">
                                <input id="DisplayViews" name="DisplayViews" value="true" type="checkbox" class="input-checkbox" v-model="material.DisplayViews" />
                                <label for="DisplayViews" class="input-checkbox-lbl">Отображать просмотры</label>
                            </div>
                            <div class="form-field">
                                <label class="input-text-lbl">
                                    Последовательность прохождения
                                </label>
                                <input id="FilesOrderLocked1" name="FilesOrderLocked" value="false" type="radio" class="input-radio" v-model="material.FilesOrderLocked" />
                                <label for="FilesOrderLocked1" class="input-radio-lbl">Произвольная</label>
                                <input id="FilesOrderLocked2" name="FilesOrderLocked" value="true" type="radio" class="input-radio" v-model="material.FilesOrderLocked" />
                                <label for="FilesOrderLocked2" class="input-radio-lbl">Фиксированная</label>
                            </div>
                            <div class="form-field-group">
                                <div class="form-field">
                                    <label class="input-text-lbl">
                                        Дата включения
                                        <span class="required" aria-required="true"></span>
                                    </label>
                                    <div class="input-date-lbl">
                                        <input-date name="StartDateFormatted" v-model="material.StartDateFormatted"></input-date>
                                    </div>
                                </div>
                                <div class="form-field">
                                    <label class="input-text-lbl">
                                        Дата выключения
                                        <span class="required" aria-required="true"></span>
                                    </label>
                                    <div class="input-date-lbl">
                                        <input-date name="EndDateFormatted" v-model="material.EndDateFormatted"></input-date>
                                    </div>
                                </div>
                            </div>
                            <div class="form-field">
                                <label class="input-text-lbl">
                                    Наименование кнопки просмотра
                                </label>
                                <input name="ViewButtonName" placeholder="по умолчанию - Просмотр" :class="['input-text', {'input-error': errors.has('ViewButtonName')}]" type="text" v-model="material.ViewButtonName">
                                <span class="field-validation-valid">{{ errors.first('ViewButtonName') }}</span>
                            </div>
                            <div class="form-field">
                                <label class="input-text-lbl">
                                    Наименование кнопки теста
                                </label>
                                <input name="TestButtonName" placeholder="по умолчанию - Пройти тест" :class="['input-text', {'input-error': errors.has('TestButtonName')}]" type="text" v-model="material.TestButtonName">
                                <span class="field-validation-valid">{{ errors.first('TestButtonName') }}</span>
                            </div>
                            <div class="form-field">
                                <label class="input-text-lbl">
                                    Наименование раздела Курс
                                </label>
                                <input name="CourseTabName" placeholder="по умолчанию - Курс" :class="['input-text', {'input-error': errors.has('CourseTabName')}]" type="text" v-model="material.CourseTabName">
                                <span class="field-validation-valid">{{ errors.first('CourseTabName') }}</span>
                            </div>
                            <div class="form-field">
                                <label class="input-text-lbl">
                                    Наименование раздела тест
                                </label>
                                <input name="TestTabName" placeholder="по умолчанию - Тест" :class="['input-text', {'input-error': errors.has('TestTabName')}]" type="text" v-model="material.TestTabName">
                                <span class="field-validation-valid">{{ errors.first('TestTabName') }}</span>
                            </div>
                            <div class="form-field">
                                <label class="input-text-lbl">
                                    Наименование раздела рейтинга
                                </label>
                                <input name="RatingTabName" placeholder="по умолчанию - Рейтинг" :class="['input-text', {'input-error': errors.has('RatingTabName')}]" type="text" v-model="material.RatingTabName">
                                <span class="field-validation-valid">{{ errors.first('RatingTabName') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="block-in-page closed">
                        <h2 class="margin-bottom-10 block-in-page-collapce">Настройка тестирования</h2>
                        <div class="block-in-page-detail">
                            <div class="form-field">
                                <input name="TestDisabled" id="TestDisabled" value="true" type="checkbox" class="input-checkbox"
                                       v-model="material.TestDisabled" @change.stop="toggleTestDisabled" />
                                <label for="TestDisabled" class="input-checkbox-lbl">Отключить тест</label>
                            </div>
                            <template v-if="!material.TestDisabled">
                                <div class="form-field margin-top-20">
                                    <button type="button" class="btn" @click="goToQuestions()" v-if="!material.new">Управление вопросами</button>
                                </div>
                                <div class="form-field margin-top-10">
                                    <label class="input-text-lbl">
                                        Тип теста
                                    </label>
                                    <drop-down :items="[{Id: testTypes.Simple, Name: 'Простой'}, {Id: testTypes.Interactive, Name: 'Интерактивный'}]"
                                               :dataField="'Id'"
                                               :textField="'Name'"
                                               v-model="material.TestType"></drop-down>
                                </div>
                                <div class="form-field">
                                    <label class="input-text-lbl">
                                        Комментарий
                                    </label>
                                    <textarea name="TestComment" rows="10" style="height:50px" :class="['input-memo', {'input-error': errors.has('TestComment')}]" v-model="material.TestComment"></textarea>
                                </div>
                                <div class="form-field">
                                    <label class="input-text-lbl">
                                        Приветственное сообщение
                                        <span class="required" aria-required="true">*</span>
                                    </label>
                                    <froala-editor ref="TestGreeting" name="TestGreeting"
                                                   :class="[{'input-error': errors.has('TestGreeting')}]"
                                                   height="150"
                                                   v-validate="'required'"
                                                   v-model="material.TestGreeting"
                                                   :imageUploadURL="config.apiUrl + '/api/materials/uploadFiles?fileType=Image&materialId=' + material.Id + '&projectId=' + material.ProjectId">

                                    </froala-editor>
                                    <span class="field-validation-valid">{{ errors.first('TestGreeting') }}</span>
                                </div>
                                <div class="form-field">
                                    <label class="input-text-lbl">
                                        Сколько вопросов задать пользователю? (сейчас {{material.ActiveQuestionsCount}} активных {{get_text_ending(material.ActiveQuestionsCount, ['вопрос','вопроса','вопросов'])}})
                                    </label>
                                    <touch-spin v-model="material.QuestionsToAsk" :max="material.ActiveQuestionsCount"></touch-spin>
                                </div>
                                <div class="form-field">
                                    <label class="input-text-lbl">
                                        На сколько вопросов должен ответить пользователь, чтобы сдать тест?
                                    </label>
                                    <touch-spin v-model="material.QuestionsToPass" :max="MaxQuestionsToPass"></touch-spin>
                                </div>
                                <div class="form-field">
                                    <input id="QuestSort" name="QuestSort" value="true" type="checkbox" class="input-checkbox" v-model="material.RandomOrder" />
                                    <label for="QuestSort" class="input-checkbox-lbl">Отображать вопросы в случайном порядке</label>
                                </div>
                                <div class="form-field">
                                    <label class="input-text-lbl">
                                        Количество попыток сдачи теста
                                    </label>
                                    <touch-spin v-model="material.TestAttemptsNumber"></touch-spin>
                                </div>
                                <div class="form-field">
                                    <label class="input-text-lbl">
                                        Интервал прохождения теста (ЧЧ:ММ:СС)
                                    </label>
                                    <input-time name="TestAttemptsIntervalFormatted"
                                                showSeconds="true"
                                                maxHours="8760"
                                                v-model="material.TestAttemptsIntervalFormatted"
                                                @input="onChangeTestAttemptsInterval()"
                                                :class="['input-text', {'input-error': errors.has('TestAttemptsIntervalFormatted')}]"></input-time>
                                </div>
                                <div class="form-field">
                                    <label class="input-text-lbl">
                                        Время на тест (в минутах)
                                    </label>
                                    <touch-spin name="TestTime"
                                                v-model="material.TestTime"
                                                v-validate="{ required: this.testInteractiveRequiredRule }"
                                                :class="['input-text', {'input-error': errors.has('TestTime')}]"></touch-spin>
                                    <span class="field-validation-valid">{{ errors.first('TestTime') }}</span>
                                </div>
                                <div class="form-field">
                                    <label class="input-text-lbl">
                                        Количество баллов за тест
                                    </label>
                                    <touch-spin name="Bonus"
                                                v-model="material.Bonus"
                                                v-validate="{ required: this.testInteractiveRequiredRule }"
                                                :class="['input-text', {'input-error': errors.has('Bonus')}]"></touch-spin>
                                    <span class="field-validation-valid">{{ errors.first('Bonus') }}</span>
                                </div>

                                <template v-if="material.TestType === testTypes.Interactive">

                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Стоимость верного ответа
                                        </label>
                                        <touch-spin name="TestRightAnswerBonus"
                                                    v-model="material.TestRightAnswerBonus"
                                                    v-validate="{ required: true }"
                                                    :class="['input-text', {'input-error': errors.has('TestRightAnswerBonus')}]"></touch-spin>
                                        <span class="field-validation-valid">{{ errors.first('TestRightAnswerBonus') }}</span>
                                    </div>
                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Стоимость неверного ответа
                                        </label>
                                        <touch-spin name="TestWrongAnswerBonus"
                                                    v-model="material.TestWrongAnswerBonus"
                                                    v-validate="{ required: true }"
                                                    :class="['input-text', {'input-error': errors.has('TestWrongAnswerBonus')}]"></touch-spin>
                                        <span class="field-validation-valid">{{ errors.first('TestWrongAnswerBonus') }}</span>
                                    </div>
                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Стоимость 1 секунды
                                        </label>
                                        <touch-spin name="TestSecondBonus" :decimals="2" :step="0.01"
                                                    v-model="material.TestSecondBonus"
                                                    v-validate="{ required: true }"
                                                    :class="['input-text', {'input-error': errors.has('TestSecondBonus')}]"></touch-spin>
                                        <span class="field-validation-valid">{{ errors.first('TestSecondBonus') }}</span>
                                    </div>

                                </template>

                                <div class="form-field">
                                    <input id="TestDisplayRating" name="TestDisplayRating" value="true" type="checkbox" class="input-checkbox" v-model="material.TestDisplayRating" />
                                    <label for="TestDisplayRating" class="input-checkbox-lbl">Показать рейтинг</label>
                                </div>
                                <div class="form-field">
                                    <input id="TestDisplayStats" name="TestDisplayStats" value="true" type="checkbox" class="input-checkbox" v-model="material.TestDisplayStats" />
                                    <label for="TestDisplayStats" class="input-checkbox-lbl">Показать статистику ответов</label>
                                </div>
                            </template>
                        </div>
                    </div>

                    <div class="block-in-page closed">
                        <h2 class="margin-bottom-10 block-in-page-collapce">Настройка изображения для сайта</h2>
                        <div class="block-in-page-detail flex">
                            <image-setting :img="imgSite" :name="'site'" :parentImage="true" @onImageViewChanged="onImageViewChanged"></image-setting>
                            <div class="form-field" style="width:300px;min-width:300px;margin-left:20px">
                                <div class="panel-block panel-block-new" style="margin-right:0">
                                    <div class="panel-block-img-base">
                                        <div class="panel-block-img">
                                            <img :src="imgSitePath" alt="" :style="imageStyleFormatted" v-if="imgSitePath" />
                                        </div>
                                    </div>
                                    <div class="panel-block-info">
                                        <p class="panel-block-header margin-bottom-10">{{ material.Name }}</p>
                                        <p class="panel-body-desc">{{ material.Description }}</p>
                                    </div>
                                    <div class="panel-body-actions">
                                        <button class="btn">{{ material.ViewButtonName || 'Просмотр' }}</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="block-in-page closed">
                        <h2 class="margin-bottom-10 block-in-page-collapce">Настройка изображения для мобильного приложения</h2>
                        <div class="block-in-page-detail flex">
                            <image-setting :img="imgMobile" :parentImgPath="imgSitePath" :name="'mobile'" @onImageViewChanged="onImageViewChanged"></image-setting>
                            <div class="form-field" style="width:500px;min-width:500px;margin-left:20px">
                                <div class="panel-block panel-block-new panel-block-mobile" style="margin-right:0">
                                    <div class="flex">
                                        <div class="panel-block-img panel-block-img-mobile">
                                            <img :src="imgMobilePath" alt="" :style="imageStyleMobileFormatted" v-if="imgMobilePath" />
                                        </div>
                                        <div class="panel-block-info">
                                            <p class="panel-block-header margin-bottom-10" >{{ material.Name }}</p>
                                        </div>
                                    </div>
                                    <div class="panel-body-actions">
                                        <button class="btn">{{ material.ViewButtonName || 'Просмотр' }}</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <Container @drop="onDrop" :lock-axis="'y'">
                        <Draggable v-for="(materialFile, i) in materialFilesOrdered">
                            <div class="block-in-page closed">
                                <h2 class="margin-bottom-10 block-in-page-collapce">{{materialFile.Name}}</h2>
                                <div class="block-in-page-detail flex">
                                    <div style="width:100%">
                                        <div class="form-field" v-if="materialFile.ActiveContentType !== 1">
                                            <label class="input-text-lbl">
                                                Тип контента
                                            </label>
                                            <drop-down :items="activeContentTypes"
                                                       :dataField="'Id'"
                                                       :textField="'Name'"
                                                       v-model="materialFile.ActiveContentType"
                                                       @change="onActiveContentTypesChange(materialFile)"></drop-down>
                                        </div>
                                        <div class="form-field">
                                            <label class="input-text-lbl">
                                                Название
                                                <span class="required" aria-required="true">*</span>
                                            </label>
                                            <textarea :name="'FileName' + i" rows="2" style="height:60px" :class="['input-memo', {'input-error': errors.has('FileName' + i)}]"
                                                      v-validate="'required'"
                                                      v-model="materialFile.Name"
                                                      @mousedown.stop=""></textarea>
                                        </div>
                                        <div class="form-field" v-if="materialFile.ActiveContentType === 1">
                                            <drop-down :items="[{Id: 1, Name: 'MS PowerPoint презентация (ppt, pptx)'}]"
                                                       :dataField="'Id'"
                                                       :textField="'Name'"
                                                       v-model="materialFile.ActiveContentType"></drop-down>
                                        </div>

                                        <div class="form-field" v-if="materialFile.ActiveContentType === 2">
                                            <label class="input-text-lbl">
                                                URL на ролик на youtube (например, https://www.youtube.com/embed/ID)
                                            </label>
                                            <input :name="'ContentLink' + i" :class="['input-text', {'input-error': errors.has('ContentLink' + i)}]" type="text"
                                                   data-vv-as="URL на ролик на youtube"
                                                   v-validate="{url: true, youtube: true}"
                                                   v-model="materialFile.ContentFileName"
                                                   @mousedown.stop="">
                                            <span class="field-validation-valid">{{ errors.first('ContentLink' + i) }}</span>
                                        </div>

                                        <div class="form-field-group margin-top-20 margin-bottom-20" v-if="materialFile.ActiveContentType === 3">
                                            <div class="form-field">
                                                <div class="file-upload-zone" :class="[{'input-error': errors.has('pdfDropFiles' + i)}]">
                                                    <input type="file" class="file-upload-zone-btn" accept=".pdf"
                                                           :ref="'pdfDropFiles' + i"
                                                           :id="'pdfDropFiles' + i"
                                                           :name="'pdfDropFiles' + i"
                                                           @change="onFileChange($event, materialFile)" />
                                                    <label :for="'pdfDropFiles' + i" class="file-upload-zone-lbl">Выберите материал (pdf файл)</label>
                                                </div>
                                                <div v-if="materialFile.ContentFileName != null" class="fileList">
                                                    Выбран файл: {{ materialFile.ContentFileName.replace('uploads/materials/' + material.ProjectId + '/' + material.Id + '/', '') }}
                                                </div>
                                                <div class="btns flex">
                                                    <button type="button" class="btn btn-delete margin-top-15"
                                                            @click="removeContentFile(materialFile)"
                                                            v-if="materialFile.ContentFileName && !materialFile.DeleteContentFile">
                                                        Удалить
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-field-group margin-top-20 margin-bottom-20" v-if="materialFile.ActiveContentType === 4">
                                            <div class="form-field">
                                                <input type="file" :id="'videoDropFiles' + i" :ref="'videoDropFiles' + i" :name="'videoDropFiles' + i"
                                                       class="file-upload-zone-btn" accept=".mp4" @change="onVideoFileChange($event, materialFile)" />
                                                <button type="button" class="btn" @click="$refs['videoDropFiles' + i][0].click()" v-if="materialFile.ContentFileName == null">
                                                    Загрузить
                                                </button>
                                                <div v-if="materialFile.ContentFileName != null" class="fileList">
                                                    Выбран файл: {{ materialFile.ContentFileName.replace('uploads/materials/' + material.ProjectId + '/' + material.Id + '/', '') }}
                                                </div>
                                                <div class="btns flex">
                                                    <button type="button" class="btn btn-delete margin-top-15"
                                                            @click="removeContentFile(materialFile)"
                                                            v-if="materialFile.ContentFileName && !materialFile.DeleteContentFile">
                                                        Удалить
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-field-group margin-top-20 margin-bottom-20" v-if="materialFile.ActiveContentType === 5">
                                            <div class="form-field">
                                                <div class="file-upload-zone" :class="[{'input-error': errors.has('scormDropFiles' + i)}]">
                                                    <input type="file" class="file-upload-zone-btn" accept=".zip"
                                                           :ref="'scormDropFiles' + i"
                                                           :id="'scormDropFiles' + i"
                                                           :name="'scormDropFiles' + i" @change="onFileChange($event, materialFile)" />
                                                    <label :for="'scormDropFiles' + i" class="file-upload-zone-lbl">Выберите материал (zip файл)</label>
                                                </div>
                                                <div v-if="materialFile.ContentFileName != null" class="fileList">
                                                    Выбран файл: {{ materialFile.ContentFileName.replace('uploads/materials/' + material.ProjectId + '/' + material.Id + '/', '') }}
                                                </div>
                                                <div class="btns flex">
                                                    <button type="button" class="btn btn-delete margin-top-15"
                                                            @click="removeContentFile(materialFile)"
                                                            v-if="materialFile.ContentFileName && !materialFile.DeleteContentFile">
                                                        Удалить
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-field margin-bottom-20" v-if="materialFile.ActiveContentType === 5">
                                            <label class="input-text-lbl">
                                                Локальный путь к начальной странице scorm (например, /data/index.html)
                                                <span class="required" aria-required="true">*</span>
                                            </label>
                                            <input :name="'ScormStartPath' + i" :class="['input-text', {'input-error': errors.has('ScormStartPath' + i)}]" type="text"
                                                   v-validate="{required: true}"
                                                   data-vv-as="Локальный путь"
                                                   v-model="materialFile.ScormStartPath">
                                            <span class="field-validation-valid">{{ errors.first('ScormStartPath' + i) }}</span>
                                        </div>

                                        <div class="form-field-group margin-top-20 margin-bottom-20" v-if="materialFile.ActiveContentType === 5">
                                            <div class="form-field">
                                                <label class="input-text-lbl">
                                                    Изображение-заглушка для scorm-курса
                                                </label>
                                                <input type="file" :id="'scormStubDropFiles' + i" :ref="'scormStubDropFiles' + i" :name="'scormStubDropFiles' + i"
                                                       class="file-upload-zone-btn" accept=".jpg,.jpeg,.png" @change="onScormStubFileChange($event, materialFile)" />
                                                <button type="button" class="btn" @click="$refs['scormStubDropFiles' + i][0].click()" v-if="materialFile.ScormStubFileName == null">
                                                    Загрузить
                                                </button>
                                                <div v-if="materialFile.ScormStubFileName != null" class="fileList">
                                                    Выбран файл: {{ materialFile.ScormStubFileName.replace('uploads/materials/' + material.ProjectId + '/' + material.Id + '/', '') }}
                                                </div>
                                                <div class="btns flex">
                                                    <button type="button" class="btn btn-delete margin-top-15"
                                                            @click="removeScormStubFile(materialFile)"
                                                            v-if="materialFile.ScormStubFileName && !materialFile.DeleteScormStubFile">
                                                        Удалить
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <button type="button" class="btn btn-delete" @click="deleteFileMaterial(i)">Удалить материал</button>
                                    </div>
                                </div>
                            </div>
                        </Draggable>
                    </Container>

                    <template v-if="!material.TestDisabled">
                        <div class="block-in-page closed">
                            <h2 class="margin-bottom-10 block-in-page-collapce">Выдать сертификат</h2>
                            <div class="block-in-page-detail">
                                <div class="form-field">
                                    <input name="SertActived" id="SertActived" value="true" type="checkbox" class="input-checkbox"
                                           v-model="material.CertificateSettings.Issuance.Actived" />
                                    <label for="SertActived" class="input-checkbox-lbl">Активировать</label>
                                </div>

                                <template v-if="material.CertificateSettings.Issuance.Actived">

                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Перед сдачей
                                        </label>
                                        <input name="SertBeforeSurrender" :class="['input-text', {'input-error': errors.has('Sertificate')}]" type="text" v-model="material.CertificateSettings.Issuance.data.front">
                                    </div>

                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            До выдачи
                                        </label>
                                        <input name="SertBeforeIssuance" :class="['input-text', {'input-error': errors.has('Sertificate')}]" type="text" v-model="material.CertificateSettings.Issuance.data.before">
                                    </div>

                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            После выдачи
                                        </label>
                                        <input name="SertAftreIssuance" :class="['input-text', {'input-error': errors.has('Sertificate')}]" type="text" v-model="material.CertificateSettings.Issuance.data.after">
                                    </div>

                                    <div class="line-separator margin-bottom-15 margin-top-20"></div>

                                    <div class="form-field">
                                        <label class="input-text-lbl">
                                            Тип уведомления
                                        </label>
                                    </div>

                                    <div class="form-field margin-top-10">
                                        <input id="sertEmailEnabled" name="SertEmailEnabled" value="true" type="checkbox" class="input-checkbox" v-model="material.CertificateSettings.Issuance.data.email" />
                                        <label for="sertEmailEnabled" class="input-checkbox-lbl">email</label>
                                    </div>

                                    <div class="form-field">
                                        <input id="sertSmsEnabled" name="SertSmsEnabled" value="true" type="checkbox" class="input-checkbox" v-model="material.CertificateSettings.Issuance.data.sms" />
                                        <label for="sertSmsEnabled" class="input-checkbox-lbl">sms</label>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </template>

                    <div class="block-in-page-detail" style="min-height: 40px;">
                        <button type="button" class="btn btn-primary" @click="addFileMaterial()">Добавить материал</button>
                    </div>

                </div>
            </div>
        </template>

        <vue-headful title="Материалы" />
    </div>
</template>

<script>
    import BackendApi from '../../backendApi'
    import $ from 'jquery'
    import UI from '../../helpers/ui-helpers'
    import moment from 'moment'
    import projectMixin from '../../helpers/project-mixin'
    import pdfjs from 'pdfjs-dist/webpack'
    import config from '../../config'
    import _ from 'lodash'
    import { Container, Draggable } from "vue-smooth-dnd"

    let backendApi = new BackendApi();

    let ImageStyleDefault = {
        top: 0,
        left: 100,
        translateY: 0,
        translateX: -50,
        size: 100,
        resizeType: 1
    },
        StubImageStyleDefault = {
        top: 50,
        left: 50,
        translateY: -50,
        translateX: -50,
        size: 100,
        resizeType: 1
    };

    export default {
        name: "material-edit",

        props: ['info'],

        mixins: [projectMixin],

        components: { Container, Draggable },

        data() {
            return {
                material: null,
                file: null,
                previousStatusId: 0,
                folders: [],
                activeContentTypes: [
                    // {Id: 1, Name: 'MS PowerPoint презентация (ppt, pptx)'},
                    {Id: 2, Name: 'Видео с YouTube'},
                    {Id: 3, Name: 'Презентация в формате PDF'},
                    {Id: 4, Name: 'Видео'},
                    {Id: 5, Name: 'Scorm-курс'}
                ],
                testTypes:{
                    Simple: 1,
                    Interactive: 2
                },
                config,
                imgSitePath: null,
                imgSite: {},
                imgMobilePath: null,
                imgMobile: {},
                savingInProgress: false
            }
        },

        computed:{
            materialFilesOrdered(){
                return _.orderBy(this.material.Files, 'OrderValue');
            },

            imageStyleFormatted() {
                let settings = {
                    left: this.imgSite.ImageStyle.left + '%',
                    top: this.imgSite.ImageStyle.top + '%',
                    transform: 'translateY(' + this.imgSite.ImageStyle.translateY + '%) translateX(' +
                        this.imgSite.ImageStyle.translateX + '%)'
                };
                if (this.imgSite.ImageStyle.resizeType === 1 && parseInt(this.imgSite.ImageStyle.size)) {
                    settings.height = this.imgSite.ImageStyle.size + '%';
                }
                if (this.imgSite.ImageStyle.resizeType === 2 && parseInt(this.imgSite.ImageStyle.size)) {
                    settings.width = this.imgSite.ImageStyle.size + '%';
                }

                return settings;
            },

            imageStyleMobileFormatted() {
                let settings = {
                    left: this.imgMobile.ImageStyle.left + '%',
                    top: this.imgMobile.ImageStyle.top + '%',
                    transform: 'translateY(' + this.imgMobile.ImageStyle.translateY + '%) translateX(' +
                        this.imgMobile.ImageStyle.translateX + '%)'
                };
                if (this.imgMobile.ImageStyle.resizeType === 1 && parseInt(this.imgMobile.ImageStyle.size)) {
                    settings.height = this.imgMobile.ImageStyle.size + '%';
                }
                if (this.imgMobile.ImageStyle.resizeType === 2 && parseInt(this.imgMobile.ImageStyle.size)) {
                    settings.width = this.imgMobile.ImageStyle.size + '%';
                }

                return settings;
            },

            stubImageStyleFormatted(){
                let settings = {
                    left: this.material.StubImageStyle.left + '%',
                    top: this.material.StubImageStyle.top + '%',
                    transform: 'translateY(' + this.material.StubImageStyle.translateY + '%) translateX(' +
                    this.material.StubImageStyle.translateX + '%)'
                };
                if(this.material.StubImageStyle.resizeType === 1 && parseInt(this.material.StubImageStyle.size)){
                    settings.height = this.material.StubImageStyle.size + '%';
                }
                if(this.material.StubImageStyle.resizeType === 2 && parseInt(this.material.StubImageStyle.size)){
                    settings.width = this.material.StubImageStyle.size + '%';
                }

                return settings;
            },

            testInteractiveRequiredRule(){
                return this.material.TestType === this.testTypes.Interactive;
            },

            testAttemptsIntervalDisabled(){
                return !(this.material.TestAttemptsNumber > 0);
            },

            testAttemptsIntervalRequiredRule(){
                return this.material.TestAttemptsNumber > 0;
            },

            MaxQuestionsToPass(){
                if(this.material.QuestionsToAsk > 0){
                    return this.material.QuestionsToAsk;
                }
                else{
                    return this.material.ActiveQuestionsCount;
                }
            }
        },

        methods: {
            onDrop(dropResult){
                let vm = this;

                if(dropResult.removedIndex === dropResult.addedIndex){
                    return;
                }

                let dataTemp = _.orderBy(vm.material.Files, 'OrderValue');
                let itemToAdd;
                if (dropResult.removedIndex != null) {
                    itemToAdd = dataTemp.splice(dropResult.removedIndex, 1)[0];
                }
                if (dropResult.addedIndex !== null) {
                    dataTemp.splice(dropResult.addedIndex, 0, itemToAdd)
                }

                let order = 1;
                dataTemp.forEach((entity) => {
                    entity.OrderValue = order++;
                });

                vm.material.Files = dataTemp;
            },

            addFileMaterial(){
                let orderValue = this.material.Files.length + 1;

                this.material.Files.push({
                    Name: 'Новый материал',
                    ActiveContentType: 3,
                    ContentFileName: null,
                    ContentPages: null,
                    OrderValue: orderValue
                })
            },

            deleteFileMaterial(i){
                this.material.Files.splice(i, 1);
            },

            toggleTestDisabled(){
                let vm = this;
                if(!vm.material.TestDisabled){
                    vm.$nextTick(() => {
                        vm.initFroala();
                    });
                }
            },

            onFileChange($event, materialFile){
                let files = $event.target.files;

                if (files && files[0]) {
                    if (files[0].size > 50 * 1024 * 1024) {
                        UI.toastr.error('Превышен размер. Выберите другой файл');
                        // todo:
                        //$('[name="dropFiles3"]').val('');
                    } else {
                        materialFile.ContentFileName = files[0].name;

                        let reader = new FileReader();
                        reader.onload = function (e) {
                            materialFile.ContentFileData = e.target.result;

                            if(materialFile.ActiveContentType === 3) {
                                let loadingTask = pdfjs.getDocument({data: atob(e.target.result.replace('data:application/pdf;base64,', ''))});
                                loadingTask.promise.then(function (pdf) {
                                    materialFile.ContentPages = pdf.numPages;
                                    materialFile.DeleteContentFile = false;
                                });
                            }
                        };
                        reader.readAsDataURL(files[0]);
                    }
                }
            },

            onActiveContentTypesChange(materialFile){
                materialFile.ContentFileName = null;
                materialFile.ContentFileData = null;
            },

            onVideoFileChange($event, materialFile){

                let files = $event.target.files;
                if (files.length > 0) {
                    if (window.FormData !== undefined) {
                        let data = new FormData();
                        for (let x = 0; x < files.length; x++) {
                            data.append("file" + x, files[x]);
                        }
                        let materialId = this.$route.params.id;
                        let tokenInfo = JSON.parse(localStorage.getItem('tokenInfo') == null ? sessionStorage.getItem('tokenInfo') : localStorage.getItem('tokenInfo'));
                        let headers = {};
                        if(tokenInfo != null){
                            headers.Authorization = 'bearer ' + tokenInfo.access_token;
                        }

                        UI.blockUI('#app');
                        $.ajax({
                            type: "POST",
                            url: config.apiUrl + '/api/materials/import?materialId=' + materialId,
                            contentType: false,
                            processData: false,
                            headers: headers,
                            data: data,
                            success: function (resp) {
                                console.info('materials/import -> resp:', resp);
                                if (resp.hasError) {
                                    UI.toastr.error('Ошибка загрузки видео');
                                }
                                else {
                                    let data = resp.result;
                                    materialFile.ContentFileName = data;
                                    materialFile.DeleteContentFile = false;
                                }
                                UI.unblockUI('#app');
                            },
                            error: function (xhr, status, p3) {
                                UI.toastr.error('Ошибка на сервере');
                                console.error(xhr.responseText);
                                UI.unblockUI('#app');
                            }
                        });
                    } else {
                        UI.toastr.error('Браузер не поддерживает загрузку файлов HTML5!');
                    }
                }
            },

            onScormStubFileChange($event, materialFile){
                let files = $event.target.files;
                if (files && files[0]) {
                    if (files[0].size > 50 * 1024 * 1024) {
                        UI.toastr.error('Превышен размер. Выберите другой файл');
                        $event.target.value = '';
                    } else {
                        materialFile.ScormStubFileName = files[0].name;

                        let reader = new FileReader();
                        reader.onload = function (e) {
                            materialFile.ScormStubFileData = e.target.result;
                        };
                        reader.readAsDataURL(files[0]);
                    }
                }
            },

            setStubImageStyleParams(style){
                for(let p in style){
                    this.material.StubImageStyle[p] = style[p];
                }
            },

            back() {
                this.$router.back();
            },


            removeContentFile(materialFile){
                materialFile.DeleteContentFile = true;
                materialFile.ContentFileName = null;
                materialFile.ContentFileData = null;
            },

            removeScormStubFile(materialFile){
                materialFile.DeleteScormStubFile = true;
                materialFile.ScormStubFileName = null;
                materialFile.ScormStubFileData = null;
            },


            goToQuestions() {
                this.$router.push(`/materials/edit/${this.material.Id}/questions`);
            },

            onStatusChanged($event, s){
                let vm = this;
                if(this.material.Status === 2) {
                    // if (!this.material.TestDisabled && (!this.material.Questions || !this.material.Questions.length)) {
                    //
                    //     UI.toastr.error('Необходимо добавить хотя бы один вопрос к презентации');
                    //     this.material.Status = this.previousStatusId;
                    //     return;
                    // }

                    // if (this.material.ConvectorStatus !== 2 && this.material.ActiveContentType == 1) {
                    //
                    //     // загружаем статус конвертации
                    //     backendApi.materialLoad(parseInt(this.$route.params.id)).then(function (response) {
                    //
                    //         if(response.data.ConvectorStatus === 2){
                    //             vm.material.Status = 2;
                    //         }
                    //         else{
                    //             UI.toastr.error('Материал презентации не сконвертирован');
                    //         }
                    //     });
                    //
                    //     this.material.Status = this.previousStatusId;
                    //     return;
                    // }
                }

                this.previousStatusId = this.material.Status;
            },

            loadMaterial() {
                let vm = this;
                let id = parseInt(this.$route.params.id);
                if (id === 0) {
                    vm.material = {
                        Id: 0,
                        new: true,
                        ImageStyle: JSON.parse(JSON.stringify(ImageStyleDefault)),
                        StubImageStyle: StubImageStyleDefault,
                        Status: 1,
                        FolderId: null,
                        ContentFileName: null,
                        FileName: null,
                        StubFileName: null,
                        StubFileData: null,
                        PresentationName: null,
                        FileData: null,
                        QuestionsToAsk: 0,
                        QuestionsToPass: 0,
                        TestAttemptsNumber: 0,
                        TestTime: 0,
                        TestRightAnswerBonus: 0,
                        TestWrongAnswerBonus: 0,
                        TestSecondBonus: 0,
                        ActiveQuestionsCount: 0,
                        Files: [],
                        FilesOrderLocked: false,
                        ProjectId: vm.projectId,
                        ScormStubFileName: null,
                        CertificateSettings: {
                            "Issuance": {
                                "Actived": null,
                                "data": {
                                    "front": null,
                                    "before": null,
                                    "after": null,
                                    "email": null,
                                    "sms": null
                                }
                            }
                        },
                        ImageStyleMobile: JSON.parse(JSON.stringify(ImageStyleDefault)),
                        ImageMobile: {}
                    };
                    vm.previousStatusId = 1;

                    let folderId = vm.$route.query.folderId;
                    if(folderId){
                        vm.material.FolderId = folderId;
                    }
                    vm.imgSite = {
                        ImageStyle: vm.material.ImageStyle,
                        ImagePath: null,
                        Image: {}
                    };
                    vm.imgMobile = {
                        ImageStyle: vm.material.ImageStyleMobile,
                        ImagePath: null,
                        Image: {}
                    };

                    return new Promise(resolve => resolve());
                }
                else {
                    return backendApi.materialLoad(id).then(function (response) {
                        //console.info('project.edit -> load, response:', response.data);
                        if (response.hasError) {
                            UI.toastr.error('Ошибка при загрузке материала');
                        }
                        else {
                            if (response.data == null) {
                                vm.$router.back();
                            }

                            if (response.data.ImageStyle) {
                                response.data.ImageStyle = JSON.parse(response.data.ImageStyle);
                            } else {
                                response.data.ImageStyle = JSON.parse(JSON.stringify(ImageStyleDefault));
                            }
                            if (response.data.ImageStyleMobile) {
                                response.data.ImageStyleMobile = JSON.parse(response.data.ImageStyleMobile);
                            } else {
                                response.data.ImageStyleMobile = JSON.parse(JSON.stringify(ImageStyleDefault));
                            }

                            if (response.data.StubImageStyle) {
                                response.data.StubImageStyle = JSON.parse(response.data.StubImageStyle);
                            } else {
                                response.data.StubImageStyle = StubImageStyleDefault;
                            }

                            if (response.data) {
                                vm.material = Object.assign(response.data, {
                                    FileName: null,
                                    DeleteImage: false,
                                    FileData: null,
                                    StubFileName: null,
                                    StubDeleteImage: false,
                                    StubFileData: null
                                });

                                vm.previousStatusId = response.data.Status;
                                if(vm.material.EndDate) {
                                    vm.material.EndDateFormatted = moment(vm.material.EndDate).format('DD.MM.YYYY');
                                }
                                if(vm.material.StartDate) {
                                    vm.material.StartDateFormatted = moment(vm.material.StartDate).format('DD.MM.YYYY');
                                }

                                vm.material.ActiveQuestionsCount = vm.material.Questions.filter(x => x.Active === true).length;

                                if(vm.material.TestAttemptsIntervalSeconds){
                                    vm.material.TestAttemptsIntervalFormatted = vm.formatTime(vm.material.TestAttemptsIntervalSeconds);
                                }
                                vm.material.CertificateSettings = JSON.parse(vm.material.CertificateSettings || '{}');
                                console.info(vm.material.CertificateSettings);
                                if (typeof vm.material.CertificateSettings.Issuance === 'undefined') {
                                    vm.material.CertificateSettings = {
                                        "Issuance": {
                                            "Actived": null,
                                            "data": {
                                                "front": null,
                                                "before": null,
                                                "after": null,
                                                "email": null,
                                                "sms": null
                                            }
                                        }
                                    };
                                }
                                vm.material.ImageMobile = {};
                                vm.imgMobile = {
                                    ImageStyle: vm.material.ImageStyleMobile,
                                    ImagePath: vm.material.ImageMobilePath,
                                    Image: {}
                                };
                                vm.imgSite = {
                                    ImageStyle: vm.material.ImageStyle,
                                    ImagePath: vm.material.Image,
                                    Image: {}
                                };
                            }
                        }
                    })
                }
            },

            saveMaterial() {
                let vm = this;

                    vm.$validator.validate().then(result => {
                        if (!result) {
                            UI.toastr.error('Проверьте введённые данные');
                        }
                        else {
                            if (vm.savingInProgress) {
                                return;
                            }
                            vm.savingInProgress = true;
                            UI.blockUI('.dataContent', 'Сохранение...');

                            let saveObj = Object.assign({}, vm.material, {
                                ProjectId: vm.projectId
                            });
                            saveObj.DeleteImage = vm.imgSite.Image.Id === -1;
                            saveObj.ImageStyle = JSON.stringify(vm.imgSite.ImageStyle);
                            saveObj.FileData = vm.imgSite.Image.FileData;
                            saveObj.FileName = vm.imgSite.Image.FileName;
                            saveObj.ImageMobile = vm.imgMobile.Image;
                            if (vm.imgMobile.ImageStyle.useMainPhoto) {
                                saveObj.ImageMobile.FileName = '';
                                saveObj.ImageMobile.FileData = '';
                                saveObj.ImageMobile.Id = -1;
                                saveObj.ImageMobilePath = '';
                            }
                            saveObj.ImageStyleMobile = JSON.stringify(vm.imgMobile.ImageStyle);
                            //saveObj.StubImageStyle = JSON.stringify(saveObj.StubImageStyle);
                            saveObj.StartDate = moment(vm.material.StartDateFormatted, 'DD.MM.YYYY').format();
                            saveObj.EndDate = moment(vm.material.EndDateFormatted, 'DD.MM.YYYY').format();
                            saveObj.CertificateSettings = JSON.stringify(saveObj.CertificateSettings);

                            // todo: проверить
                            // if(!vm.material.TestDisabled){
                            //     saveObj.TestGreeting = $('[name="TestGreeting"]').froalaEditor('html.get', true);
                            // }

                            //console.info('saveObj', saveObj)
                            backendApi.materialSave(saveObj).then(function (response) {
                                UI.unblockUI('.dataContent');
                                if (response.hasError) {
                                    UI.toastr.error('Ошибка при сохранении материала');
                                } else {
                                    UI.toastr.success('Успешно сохранено');
                                    if (vm.material.new) {
                                        if (vm.material.TestDisabled) {
                                            vm.$router.push('/materials/edit/' + response.data.Id);
                                        } else {
                                            vm.$router.push('/materials/edit/' + response.data.Id + '/questions');
                                        }
                                    }
                                    else {
                                        vm.loadMaterial();
                                    }
                                }
                                vm.savingInProgress = false;
                            });
                        }
                    });
            },

            deleteMaterial() {
                let vm = this;

                if (confirm('Вы уверены?')) {
                    UI.blockUI('.dataContent', 'Удаление...');
                    backendApi.materialDelete(vm.material.Id).then(function (response) {
                        UI.unblockUI('.dataContent');
                        if (response.hasError) {
                            UI.toastr.error('Ошибка при удалении материала');
                        } else {
                            UI.toastr.success('Успешно удалено');
                            vm.$router.push('/materials');
                        }
                    });
                }
            },

            loadFolders(){
                let vm = this;

                let projectId = vm.projectId;

                return backendApi.folderList(projectId).then(function (response) {
                    if (response.hasError) {
                        UI.toastr.error('Ошибка при загрузке папок материалов');
                    }
                    else {
                        vm.folders = response.data;
                    }
                });
            },

            onChangeTestAttemptsInterval(){
                let parts = this.material.TestAttemptsIntervalFormatted.split(':');
                let h = parseInt(parts[0]),
                    m = parseInt(parts[1]),
                    s = parseInt(parts[2]);

                this.material.TestAttemptsIntervalSeconds = h*3600 + m*60 + s;
            },

            formatTime(time){
                let h = Math.floor(time / 3600);
                let m = Math.floor((time - h * 3600) / 60);
                let s = Math.floor(time - h * 3600 - m*60);

                return (h > 9 ? h : '0' + h) + ':' + (m > 9 ? m : '0' + m) + ':' + (s > 9 ? s : '0' + s);
            },

            onImageViewChanged(imgPath, name) {
                if (name === 'site')
                    this.imgSitePath = imgPath;
                else
                    this.imgMobilePath = imgPath;
            }
        },

        mounted() {
            let vm = this;

            UI.blockUI('.dataContent', 'Загрузка...');
            this.loadFolders().then(() => vm.loadMaterial().then(() => {
                UI.unblockUI('.dataContent');

                $(document).on('click', '.block-in-page-collapce', function () {
                    UI.block_collapse(this);
                });

            }));

        },

        destroyed() {
            // $(document).off('change', '[name="dropFiles3"]');
            // $(document).off('change', '[name="dropFiles4"]');
            $(document).off('click', '.block-in-page-collapce');
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Content/src/views/edit/MaterialEdit.vue